import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      let data = {};
      try { data = await res.json(); } catch (parseErr) { console.warn('Response parse error:', parseErr); }
      if (!res.ok) throw new Error(data.detail || 'Invalid credentials');
      sessionStorage.setItem('vp_admin_token', data.token);
      navigate('/admin');
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#0B1B3D' }}>
      <div className="w-full max-w-sm mx-4">
        {/* Logo area */}
        <div className="text-center mb-10">
          <p className="text-xs tracking-[0.3em] uppercase mb-2" style={{ color: '#D4AF37' }}>Vimal Plastics</p>
          <h1 className="text-2xl font-light text-white" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Admin Panel
          </h1>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-xs tracking-[0.15em] uppercase mb-2" style={{ color: 'rgba(255,255,255,0.5)' }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              className="w-full px-4 py-3 text-sm bg-transparent text-white outline-none"
              style={{ border: '1px solid rgba(255,255,255,0.15)', borderRadius: 0 }}
              placeholder="admin@vimalplastics.com"
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label className="block text-xs tracking-[0.15em] uppercase mb-2" style={{ color: 'rgba(255,255,255,0.5)' }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              className="w-full px-4 py-3 text-sm bg-transparent text-white outline-none"
              style={{ border: '1px solid rgba(255,255,255,0.15)', borderRadius: 0 }}
              placeholder="••••••••"
              data-testid="admin-password-input"
            />
          </div>

          {error && (
            <p className="text-xs text-red-400 tracking-wide" data-testid="admin-login-error">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3.5 text-xs tracking-[0.2em] uppercase font-medium transition-opacity hover:opacity-85 disabled:opacity-50"
            style={{ backgroundColor: '#D4AF37', color: '#0B1B3D' }}
            data-testid="admin-login-btn"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className="text-center mt-8 text-xs" style={{ color: 'rgba(255,255,255,0.2)' }}>
          Vimal Plastics Website Admin
        </p>
      </div>
    </div>
  );
}
